import { LeadScoreCategory } from "../../../types"

export const CATEGORY_CONFIG: Record<
  LeadScoreCategory,
  {
    label: string
    labelPlural: string
    borderClass: string
    badgeClass: string
    cardAccentClass: string
    pillActiveClass: string
  }
> = {
  hot_lead: {
    label: "Hot Lead",
    labelPlural: "Hot Leads",
    borderClass: "border-l-red-400",
    badgeClass: "badge-danger",
    cardAccentClass: "border-t-red-400",
    pillActiveClass: "bg-red-50 border-red-400 text-red-700"
  },
  needs_contact: {
    label: "Needs Contact",
    labelPlural: "Needs Contact",
    borderClass: "border-l-yellow-400",
    badgeClass: "badge-warning",
    cardAccentClass: "border-t-yellow-400",
    pillActiveClass: "bg-yellow-50 border-yellow-400 text-yellow-700"
  },
  engaged: {
    label: "Engaged",
    labelPlural: "Engaged",
    borderClass: "border-l-primary-400",
    badgeClass: "badge-info",
    cardAccentClass: "border-t-primary-400",
    pillActiveClass: "bg-teal-50 border-teal-500 text-teal-700"
  },
  dormant: {
    label: "Dormant",
    labelPlural: "Dormant",
    borderClass: "border-l-neutral-300",
    badgeClass: "badge-disabled",
    cardAccentClass: "border-t-neutral-300",
    pillActiveClass: "bg-neutral-100 border-neutral-400 text-neutral-600"
  },
  at_risk: {
    label: "At Risk",
    labelPlural: "At Risk",
    borderClass: "border-l-purple-400",
    badgeClass: "badge-alt",
    cardAccentClass: "border-t-purple-400",
    pillActiveClass: "bg-violet-50 border-violet-400 text-violet-700"
  }
}

/**
 * Clean suggested action text so it reads as a direct instruction to the LO
 * rather than a third-person description (e.g. "LO 1930 should reach out" → "Reach out")
 */
export const cleanSuggestedAction = (text: string) => {
  const cleaned = text.replace(
    /^(?:LO\s+#?\d+|The\s+(?:loan\s+officer|LO))\s+should\s+/i,
    ""
  )
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1)
}

export const CATEGORIES: LeadScoreCategory[] = [
  "hot_lead",
  "needs_contact",
  "engaged",
  "dormant",
  "at_risk"
]
